/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Coverage_MissingInputs */

const en_keyword_optimizer_coverage_missing = /** @type {(inputs: Keyword_Optimizer_Coverage_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`missing`)
};

const de_keyword_optimizer_coverage_missing = /** @type {(inputs: Keyword_Optimizer_Coverage_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`missing`)
};

const fr_keyword_optimizer_coverage_missing = /** @type {(inputs: Keyword_Optimizer_Coverage_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`missing`)
};

const es_keyword_optimizer_coverage_missing = /** @type {(inputs: Keyword_Optimizer_Coverage_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`missing`)
};

const it_keyword_optimizer_coverage_missing = /** @type {(inputs: Keyword_Optimizer_Coverage_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`missing`)
};

const nl_keyword_optimizer_coverage_missing = /** @type {(inputs: Keyword_Optimizer_Coverage_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`missing`)
};

const pl_keyword_optimizer_coverage_missing = /** @type {(inputs: Keyword_Optimizer_Coverage_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`missing`)
};

const fi_keyword_optimizer_coverage_missing = /** @type {(inputs: Keyword_Optimizer_Coverage_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`missing`)
};

const da_keyword_optimizer_coverage_missing = /** @type {(inputs: Keyword_Optimizer_Coverage_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`missing`)
};

const sv_keyword_optimizer_coverage_missing = /** @type {(inputs: Keyword_Optimizer_Coverage_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`missing`)
};

/**
* | output |
* | --- |
* | "missing" |
*
* @param {Keyword_Optimizer_Coverage_MissingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_coverage_missing = /** @type {((inputs?: Keyword_Optimizer_Coverage_MissingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Coverage_MissingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_coverage_missing(inputs)
	if (locale === "fr") return fr_keyword_optimizer_coverage_missing(inputs)
	if (locale === "es") return es_keyword_optimizer_coverage_missing(inputs)
	if (locale === "it") return it_keyword_optimizer_coverage_missing(inputs)
	if (locale === "nl") return nl_keyword_optimizer_coverage_missing(inputs)
	if (locale === "pl") return pl_keyword_optimizer_coverage_missing(inputs)
	if (locale === "fi") return fi_keyword_optimizer_coverage_missing(inputs)
	if (locale === "da") return da_keyword_optimizer_coverage_missing(inputs)
	if (locale === "sv") return sv_keyword_optimizer_coverage_missing(inputs)
	return en_keyword_optimizer_coverage_missing(inputs)
});